export const SYNC_FIRMWARE_CHANNEL = '@@firmware/sync'
export const SYNC_SENT_FIRMWARE_CHANNEL = '@@firmware/syncSent'
export const SYNC_CANCEL_FIRMWARE_CHANNEL = '@@firmware/syncCancelled'
export const SYNC_DONE_FIRMWARE_CHANNEL = '@@firmware/syncDone'
export const UPDATE_FIRMWARE_CHANNEL = '@@firmware/update'

export const SAVE_AVAILABLE_FIRMWARES = '@@firmware/saveAvailableFirmwares'

export const SET_FIRMWARE_FOR_UPDATE = '@@firmware/setFirmwareForUpdate'

export const START_FIRMWARE_UPDATE = '@@firmware/startFirmwareUpdate'
export const CANCEL_FIRMWARE_UPDATE = '@@firmware/cancelFirmwareUpdate'
export const SET_FIRMWARE_STATUS = '@@firmware/setFirmwareStatus'
export const RESET_FIRMWARE_STATUS = '@@firmware/resetFirmwareStatus'
